export let cms1500JobsFields = {
  id: "id",
  formAnswerGroupId: "form_answer_group_id",
  patientId: "patient_id",
  appointmentId: "appointment_id",
  status: "status",
  healthieCms1500Id: "healthie_cms1500_id",
  attemptCount: "attempt_count",
  lastErrorMessage: "last_error_message",
  lastAttemptedAt: "last_attempted_at",
  retryInitiatedAt: "retry_initiated_at",
  createdAt: "created_at",
  updatedAt: "updated_at",
};
